<div class="expand-container">
  <span
    class="material-icons expand-icon"
    matTooltip="{{ tooltip }}"
    [class.disabled]="disabled"
    [class.expanded]="expanded"
    (click)="toggle()"
  >
    {{ expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
  </span>
</div>
